module.exports = __webpack_public_path__ + "img/iexcel.cb7f7670.svg";